import { render, staticRenderFns } from "./AuthSignupDemoForm.vue?vue&type=template&id=00b2c1cd"
import script from "./AuthSignupDemoForm.vue?vue&type=script&lang=js"
export * from "./AuthSignupDemoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports